import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { CtAdminLogin } from 'containers';

class AdminLoginPage extends Component {
  render() {
    return <CtAdminLogin />;
  }
}

export default AdminLoginPage;



// WEBPACK FOOTER //
// ./src/script/pages/AdminLoginPage.js